<button data-cy="pdf-view__close-btn" type="button" class="close no-margin modal-close-icon" (click)="close()" matTooltip="{{ 'close' | transloco | capitaliz }}"><span aria-hidden="true">
    <mat-icon class="d-text-middle">close</mat-icon>
</span><span class="sr-only">Close</span></button>
<embed [src]="data.attachment_url | safeURL" type="application/pdf" width="100%" height="500px">